import React from "react";
import "./About.css";
import profileImage from "../images/Moi1.jpg"; // Remplace par ton image

const About = () => {
  return (
    <section id="about" className="about-section">
      {/* Titre encadré */}
      <div className="about-title">
        <h1>À PROPOS DE MOI</h1>
      </div>

      {/* Contenu principal */}
      <div className="about-container">
        {/* Partie gauche - Image */}
        <div className="about-image">
          <img src={profileImage} alt="Mon portrait" />
        </div>

        {/* Partie droite - Texte */}
        <div className="about-text">
          <h2>Qui suis-je ?</h2>
          <p>
            Passionné par le <strong>Cloud Computing</strong> et la <strong>Cybersécurité</strong>, actuellement en Master 2 Cloud Computing & Cybersecurity à
            l'Université de Lille, rigoureux et motivé en quête de nouvelles opportunités. 
          </p>
          <p>
            J'aime apprendre, partager mes connaissances et échanger sur des sujets comme le <strong>DevOps</strong>,
            la <strong>Cybersécurité</strong> et l'<strong>auto-formation</strong>. 
            Mon portfolio présente mes projets, compétences, experiences et certifications dans le domaine de l'informatique.
          </p>
          <p>
            Actuellement à la recherche d'un <strong>stage de 4-6 mois à partir de mars 2026.</strong>, Je souhaite appliquer et
            renforcer mes compétences en sécurité des infrastructures et cloud au sein d'un environnement stimulant, en faisant 
            preuve de motivation et d'esprit d'équipe.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
